// import React, { useState } from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { QuestionTechnologyFormValues } from "src/models/QuestionTechnology.model";

type Props = {
  formikProps: FormikProps<QuestionTechnologyFormValues>;
  onClose: () => void;
  editorValue?: string;
  formType: "Add" | "Edit";
  setSaveNextChecked?: any;
  saveNextChecked?: any;
};


const QuestionTechnologyForm = ({
  formikProps,
  onClose,
  editorValue,
  formType,
  setSaveNextChecked,
  saveNextChecked,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="flex flex-col flex-1 gap-4 p-4 overflow-hidden">
      <div className="flex items-center justify-between h-fit">
        <div className="text-xl font-medium">
          {formType === "Add" ? "Add Question Technology" : "Update Question Technology"}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="h-full">
        {/* comapany name */}
        <ATMTextField
          required
          name="category"
          value={values?.category}
          onChange={(e) => setFieldValue("category", e.target.value)}
          label="Technology "
          placeholder="Enter Technology "
          onBlur={handleBlur}
        />

      </div>

      <div className="h-fit">
        {formType === "Add" && (
          <div>
            <ATMCheckbox
              label="Save and Next"
              checked={saveNextChecked}
              onChange={(checked) => {
                setSaveNextChecked(checked);
              }}
            />
          </div>
        )}
        <div>
          <ATMLoadingButton isLoading={isSubmitting} type="submit">
            Save
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default QuestionTechnologyForm;
